// src/components/LogoIcon.js
import React from 'react';
import Logo from '../img/images/SRRlogo.png'; // Adjust the path as necessary

function LogoIcon({ width = '100%', height = '100%' }) {
  return (
    <img
      src={Logo}
      alt="SRR-Intech Logo"
      style={{
        width,
        height,
        maxWidth: '100px',
        maxHeight: '100px',
        objectFit: 'contain',
      }}
    />
  );
}

export default LogoIcon;
